export const viewOutline = (props: any) => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath="url(#clip0_40001724_4137)">
        <path
          d='M10.0002 2.5C14.4935 2.5 18.2319 5.73333 19.016 10C18.2327 14.2667 14.4935 17.5 10.0002 17.5C5.50687 17.5 1.76854 14.2667 0.984375 10C1.76771 5.73333 5.50687 2.5 10.0002 2.5ZM10.0002 15.8333C11.6998 15.833 13.3489 15.2557 14.6776 14.196C16.0063 13.1363 16.936 11.6569 17.3144 10C16.9346 8.34442 16.0043 6.86667 14.6757 5.80835C13.3471 4.75004 11.6988 4.17377 10.0002 4.17377C8.30162 4.17377 6.65328 4.75004 5.32469 5.80835C3.99609 6.86667 3.06585 8.34442 2.68604 10C3.06446 11.6569 3.9941 13.1363 5.32283 14.196C6.65155 15.2557 8.30065 15.833 10.0002 15.8333ZM10.0002 13.75C9.00565 13.75 8.05182 13.3549 7.34856 12.6516C6.6453 11.9484 6.25021 10.9946 6.25021 10C6.25021 9.00544 6.6453 8.05161 7.34856 7.34835C8.05182 6.64509 9.00565 6.25 10.0002 6.25C10.9948 6.25 11.9486 6.64509 12.6519 7.34835C13.3551 8.05161 13.7502 9.00544 13.7502 10C13.7502 10.9946 13.3551 11.9484 12.6519 12.6516C11.9486 13.3549 10.9948 13.75 10.0002 13.75ZM10.0002 12.0833C10.5527 12.0833 11.0826 11.8638 11.4733 11.4731C11.864 11.0824 12.0835 10.5525 12.0835 10C12.0835 9.44747 11.864 8.91756 11.4733 8.52686C11.0826 8.13616 10.5527 7.91667 10.0002 7.91667C9.44767 7.91667 8.91777 8.13616 8.52707 8.52686C8.13637 8.91756 7.91687 9.44747 7.91687 10C7.91687 10.5525 8.13637 11.0824 8.52707 11.4731C8.91777 11.8638 9.44767 12.0833 10.0002 12.0833Z'
          fill='#3665B2'
        />
      </g>
      <defs>
        <clipPath id="clip0_40001724_4137">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export const hideOutline = (props: any) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.5931 6.41045C11.0967 6.43586 10.6736 6.05405 10.6482 5.55765C10.6228 5.06124 11.0046 4.63822 11.501 4.6128C14.2596 4.47154 17.0748 5.56601 19.1499 7.11392C20.1249 7.84126 20.9374 8.66742 21.5062 9.50942C22.0751 10.3517 22.4 11.2095 22.4 11.9999C22.4 12.9403 21.936 13.9809 21.1578 14.966C20.8497 15.3561 20.2837 15.4225 19.8937 15.1143C19.5037 14.8062 19.4372 14.2403 19.7454 13.8502C20.1553 13.3313 20.6 12.6825 20.6 11.9999C20.6 11.6876 20.4615 11.1785 20.0146 10.517C19.5786 9.8715 18.9176 9.18631 18.0736 8.55671C16.2385 7.18782 13.9051 6.29205 11.5931 6.41045Z'
        fill='#023F80'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.85008 16.886C6.80021 18.3407 9.40022 19.3999 12 19.3999C13.9672 19.3999 15.9298 18.7931 17.6042 17.877L18.8636 19.1364C19.215 19.4878 19.7849 19.4878 20.1364 19.1364C20.4878 18.7849 20.4878 18.2151 20.1364 17.8636L6.63637 4.36358C6.2849 4.01211 5.71505 4.01211 5.36358 4.36358C5.01211 4.71505 5.01211 5.2849 5.36358 5.63637L6.0475 6.3203C5.62883 6.56598 5.22813 6.83191 4.85008 7.11392C3.87505 7.84126 3.06253 8.66742 2.49377 9.50942C1.9248 10.3517 1.59998 11.2095 1.59998 11.9999C1.59998 12.7904 1.9248 13.6482 2.49377 14.4905C3.06253 15.3325 3.87505 16.1586 4.85008 16.886ZM10.4 12C10.4 12.8836 11.1163 13.6 12 13.6C12.3723 13.6 12.7145 13.4734 12.9868 13.2596L10.7403 11.0131C10.5266 11.2854 10.4 11.628 10.4 12ZM12 15.4C10.1222 15.4 8.59998 13.8777 8.59998 12C8.59998 11.13 8.92706 10.3367 9.46333 9.73613L7.36977 7.64256C6.85684 7.91605 6.37195 8.22431 5.92635 8.55671C5.08235 9.18631 4.42137 9.8715 3.98535 10.517C3.53847 11.1785 3.39998 11.6876 3.39998 11.9999C3.39998 12.3123 3.53847 12.8214 3.98535 13.4829C4.42137 14.1284 5.08235 14.8136 5.92635 15.4432C7.63079 16.7146 9.86224 17.5999 12 17.5999C13.4392 17.5999 14.925 17.1989 16.269 16.5418L14.2638 14.5366C13.6633 15.0728 12.8695 15.4 12 15.4Z'
        fill='#023F80'
      />
    </svg>
  );
};
